/**
 * Generated by orval - Do not edit manually.
 * Buildertrend API (all versions)
 * A view showing all available versions of the API. Some routes may be deprecated. Use the latest version available whenever possible.
 * OpenAPI spec version: all
 * If there are merge conflicts to this file,
 * please rebuild the Clients.Api project to resolve.
 */

/**
 * 0 = Don't Save

1 = New message received

2 = Schedule Shift

3 = Schedule Item due date reminder

4 = Change Order approved by Client

5 = New Change Order created by another user

6 = Change Order deadline updated

8 = Internal User Notification Preferences Changed

9 = Sub/Vendor Notification Preferences Changed

10 = Client Notification Preferences Changed

11 = New Warranty Request created by Client

12 = Follow-up date reminder

15 = Service appointment acceptance requested

17 = Insurance reminder

19 = Selection Choice approved by Client

20 = Selection deadline reminder

21 = New comment on a Selection

22 = Selection Choice created or updated

23 = Client requested pricing

24 = Selection pricing updated

25 = Selection Files Added

26 = Selection Choice Files Added

27 = Selection Added

28 = Schedule Item needs confirmation

29 = Files attached to a Change Order

31 = New comment on a Change Order

32 = Sub/Vendor activation complete

33 = Schedule Item confirmed by assigned user

34 = Client activation complete

35 = Service Appointment updated by Client

36 = Feedback provided by Client

37 = Service Appointment updated by Sub/Vendor

38 = New Daily Log created

39 = Warranty Coordinator Changed

40 = Service appointment date changed

41 = Selection Choice approved as a Vendor

42 = Selection Choice approved as an Installer

43 = Selection Choice Vendor Price Requested

44 = Trade Agreement Acceptance Requested To Sub/Vendor

45 = Action taken on Trade Agreement

46 = Selection Choice approved by another user

47 = Change Order approved by another user

48 = Purchase order sent by builder

49 = Purchase order approved by sub/vendor

50 = Purchase order assigned to another user

51 = Purchase order approved by another user

53 = Purchase order work completed by a sub/vendor

54 = Bill marked as paid

55 = New comment on a Purchase Order

56 = PO files added

57 = New Warranty Request created by another user

58 = Inspection reminder

59 = Lead Email Sent

60 = Lead Email Response

61 = Project Manager Changed

62 = Other employee contact

63 = New Lead Opportunity from contact form

64 = Lead salesperson changed

65 = Sub/Vendor submitted pricing

66 = Lead Activity reminder

67 = Email quota reached

68 = New comment on a Warranty Request

69 = Schedule Item declined by assigned user

70 = Files attached to assigned Warranty Services

71 = Purchase order work completed by another user

72 = New Bid Request submitted by Sub/Vendor

73 = Bid submitted by Builder

74 = Bid Request approved by Builder

75 = Bid Request released by Builder

76 = Bid Request confirmed or declined by Sub/Vendor

77 = Bid Request status reset to 'In Progress' by Builder

78 = Bid Package Changed

79 = Bid Request declined by Builder

80 = Bid Request resubmitted by Sub/Vendor

81 = Bid Package reopened

82 = Bidding Closed

83 = Bid Package Unreleased

88 = New comment on a Bid Request

89 = Bid Package deadline reminder

91 = Bid Request approved by another user

92 = Service Appointment scheduled

93 = To-Do Assigned

94 = To-Do Reminder

95 = To-Do marked complete or incomplete

96 = Files attached to a Bid Package

97 = Purchase order declined by sub/vendor

98 = Bill payment reminder

99 = New comment on a Daily Log

100 = New comment on a Schedule Item

101 = New comment on a To-Do

102 = New Change Order request from Client

103 = Builder Sent Survey

105 = New survey response from Client

106 = Assigned to a Lead Activity by another user

107 = Time sheet was changed

108 = Invoice Released

109 = Lead Proposal Released

110 = Invoice updated

111 = Overtime has been reached

112 = Payment reminder

113 = Payment past due

114 = Over 12 Hour Shift

116 = Lead Proposal accepted or declined

117 = Lead Proposal viewed

118 = Daily Log Files Added

119 = Proposal Released

120 = Estimate approved or declined

121 = Estimate viewed by Client

122 = Accept Bill Pay payment

125 = To-Do Files Added

126 = Lien waiver sent

127 = Lien waiver accepted

128 = Lien waiver declined

129 = Online Payment Invitation

130 = Invoice Files Added

131 = Payment made on Receivable

132 = New comment on an Invoice

134 = Document Annotated

135 = Document Uploaded

137 = Online Payment Receipt

139 = New comment on a Photo

140 = New comment on a Document

141 = Schedule Item Files Added

142 = Document uploaded by Client or Sub/Vendor

143 = New Invoice created

144 = Bill Converted to PO

145 = Video Uploaded

147 = New comment on a Video

148 = Lead Unsubscribe Request

149 = Files attached to a lien waiver

150 = Files attached to a purchase order by a sub/vendor

152 = To-Do Past Due

153 = Service Appointment assigned to another user

154 = Lead Proposal Payment Due Reminder

155 = Photo Added

156 = Change Order Approval Retracted

157 = Unsubscribe Confirmation

158 = New RFI created by another user

159 = RFI Reminder

160 = New response to an RFI

161 = New RFI created by Sub/Vendor

162 = RFI marked complete or incomplete

163 = RFI Assigned To You

164 = PO Voided

165 = RFI past due

166 = RFI Files Added

167 = Approved/Denied

168 = Builder's Risk Insurance policy received

169 = Builder's Risk Insurance binder received

170 = Lead Activity Updated

171 = Signature Request Assigned

172 = Signature Request signed

173 = Signature Request Reminder

174 = Signature request past due

175 = Signature Request Reset to Pending

177 = Lead clicked a link

179 = Payment made on Lead Proposal

180 = Sub/Vendor Activation Requested

181 = Mass Reassign

182 = Job viewing access granted

183 = Lead Proposal past due

184 = Estimate past due

185 = User clocked in/out outside of geofence

186 = Bid Request receipt sent

187 = Purchase order payment receipt sent

188 = New Credit Memo

190 = Internal User Activation Requested

191 = Internal User activation complete

192 = New Receipt Comment

193 = Sub/Vendor uploaded a certificate

194 = Bill marked 'Ready for payment'

195 = Payment Method Microdeposit Sent

197 = New comment on a Credit Memo

198 = Purchase order approval reminder

199 = New comment on a Bill

200 = Notification Preferences Updated

202 = Online Payment Lien Waiver Sent

203 = Bill voided by builder

204 = Sub requested bill payment

207 = QuickBooks Invoice Override

208 = Invoice Payment Receipt

209 = Bill payment receipt

210 = Receipt Uploaded

211 = Online Payment Failed

212 = Online Payment

213 = ContactActivationRequest

214 = ContactActiveOwnerJobAccessGranted

215 = New comment on a Deposit

216 = New Deposit Request created

217 = Deposit Requested

219 = Password has been updated

220 = Inbound hosted onboarding application status update

221 = Integration Setup Reminder

222 = Upcoming deposit request deadline

223 = Invite client to Buildertrend

224 = Integration Reminder

225 = Unaccepted Funds Reminder

226 = Chat message received

227 = Refund Initiated

228 = Buildertrend Payments Account Approved

229 = Payout Created

230 = Buildertrend Payments Account Rejected

231 = Financial Document Uploaded

232 = Documents Requested

233 = Payment Threshold Limit Reached

234 = Payment Total Limit Reached

236 = Reset Password

237 = Forgot Username

238 = Monthly limit set

239 = Payment declined due to limit

240 = Payment limit has been removed

241 = Payment limit has been updated

242 = Risk Insurance Jobsite Request Submitted

243 = Builder Risk Insurance Application Submitted

244 = Proposal Signature Captured

260 = Payment limit has been reset

261 = SMS Payment Link

262 = Payment Requested

263 = Client Update - published

264 = Username Change Requested

265 = Username Change Requested for Your Account

266 = Documents Requested for Inbound Verified Account

267 = Username Updated

268 = Payment Account Disabled

269 = Bill payment made from QuickBooks

270 = Client Update - available to send

271 = SMS Invoice Past Due

272 = Client Update - new comment

273 = Transaction Limit Increase Request Approved

274 = Transaction Limit Increase Request Declined

275 = Payment Confirmation on Receivable

276 = Change Order deadline reminder

277 = User @ Mention

278 = Payment Confirmation on Payable

279 = Proposal Released

280 = Bill payment failed

281 = Bill payment failed to subs

282 = ACH setup request

283 = User reacted to comment

284 = Sub bank account saved

285 = Schedule Assignment

286 = Purchase order amended

287 = Task discussion added

288 = Payments Schedule Shared

289 = Task Assignment

290 = Customer Feedback Submitted

291 = Buildertrend Payments Application Pending

292 = Buildertrend Payments Unified Account Rejected

293 = Bill approval requested

294 = Task Digest

295 = Bill approval daily summary

296 = Bill rejected

297 = Payer bank account added

298 = Default payer bank account changed

299 = Specification discussion added

300 = Bill intake email failure

301 = Plan page discussion added

302 = Task starting soon

303 = Task assignment or schedule updated

304 = Specification published

305 = New comment on a Selection Option

306 = Bill intake processing failure

307 = Bill intake sender processing failure

-9 = New way to get paid for Subs/Vendors

-7 = RFI Answer By Reminder

-6 = RFI Answered

-5 = RFI Assigned

-4 = RFI Created

-3 = PO Finalized For Payment (Obsolete)

-2 = PO Declined Internal (Obsolete)

-1 = PO Accepted/Declined By Sub/Vendor (Obsolete)


 */
export type NotificationTypes =
  (typeof NotificationTypes)[keyof typeof NotificationTypes];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationTypes = {
  DONTSAVE: 0,
  NEWMESSAGE: 1,
  SCHEDULESHIFT: 2,
  SCHEDULEREMINDER: 3,
  CHANGEORDERAPPROVED: 4,
  CHANGEORDERADDED: 5,
  CHANGEORDERNEWDEADLINE: 6,
  InternalUserNotificationPreferencesUpdated: 8,
  SubNotificationPreferencesUpdated: 9,
  OwnerNotificationPreferencesUpdated: 10,
  WARRANTYADDED: 11,
  WARRANTYNEEDSFOLLOWUP: 12,
  WARRANTYDAILYREMINDER: 15,
  INSURANCEREMINDER: 17,
  SELECTION_APPROVED: 19,
  SELECTION_DEADLINE_REMINDER: 20,
  SELECTION_DISCUSSION_ADDED: 21,
  SELECTION_CHOICE_ADDED: 22,
  SELECTION_OWNER_PRICE_REQUESTED: 23,
  SELECTION_OWNER_PRICE_ENTERED: 24,
  SELECTION_FILES_ADDED: 25,
  SELECTION_CHOICE_FILES_ADDED: 26,
  SELECTION_ADDED: 27,
  USER_NEEDS_SCHEDULE_CONFIRMATION: 28,
  CHANGEORDER_FILES_ADDED: 29,
  CHANGEORDER_DISCUSSION_ADDED: 31,
  SUB_ACTIVATION: 32,
  USER_SCHEDULE_CONFIRMED_TO_BUILDER: 33,
  HOMEOWNER_ACTIVATION: 34,
  WARRANTY_OWNER_APPOINTMENT_UPDATED: 35,
  WARRANTY_OWNER_LEFT_FEEDBACK: 36,
  WARRANTY_SUB_APPOINTMENT_UPDATED: 37,
  DAILY_LOG_NOTIFICATION: 38,
  WARRANTY_COORDINATOR_CHANGED: 39,
  WARRANTY_SCHEDULE_CHANGED: 40,
  SELECTION_APPROVED_VENDOR: 41,
  SELECTION_APPROVED_INSTALLER: 42,
  SELECTION_CHOICE_VENDOR_PRICE_REQUESTED: 43,
  TradeAgreementAcceptanceRequestedToSub: 44,
  TradeAgreementActionTaken: 45,
  SELECTION_MANUALLY_APPROVED: 46,
  CHANGEORDER_MANUALLY_APPROVED: 47,
  PO_Released_To_Sub: 48,
  PO_Accepted_By_Sub: 49,
  PO_Assigned_To_Internal_User: 50,
  PO_Manually_Approved_For_Sub: 51,
  PO_WorkComplete_ReadyForPayment: 53,
  PO_Payment_Made: 54,
  PO_DISCUSSION_ADDED: 55,
  PoFilesAdded: 56,
  WARRANTYADDED_MANUALLY: 57,
  PO_InspectWorkReminder: 58,
  LeadOutEmail: 59,
  LeadInEmail: 60,
  JOBSITE_CHANGE_PROJECT_MANAGER: 61,
  LeadNotifyWhenOtherEmployeeContact: 62,
  LeadNotifyNewLeadFromContactForm: 63,
  LeadNotifySalespersonChanged: 64,
  SELECTION_SUB_PRICE_ENTERED: 65,
  LeadNotifyActivityReminder: 66,
  LeadNotifyEmailQuotaAlert: 67,
  WARRANTY_DISCUSSION_ADDED: 68,
  USER_SCHEDULE_DECLINED_TO_BUILDER: 69,
  WarrantyFilesAdded: 70,
  PO_WorkComplete_InternallyAssigned: 71,
  Bid_SubSubmitted: 72,
  Bid_BuilderSubmitted: 73,
  Bid_Accepted: 74,
  Bid_Released: 75,
  Bid_SubConfirmStatusChanged: 76,
  Bid_ResetToInProgress: 77,
  Bid_Changed: 78,
  Bid_Declined: 79,
  Bid_SubResubmitted: 80,
  Bid_BidPackageReopened: 81,
  Bid_BiddingClosed: 82,
  Bid_BidPackageUnreleased: 83,
  Bid_DiscussionAdded: 88,
  Bid_BidPackageDeadlineReminder: 89,
  Bid_AcceptedBuilder: 91,
  WARRANTY_SUB_SCHEDULE_ADDED: 92,
  Todos_Added: 93,
  Todos_Reminder: 94,
  Todos_CompletedByOthers: 95,
  Bid_BidPackageFilesAdded: 96,
  PO_Declined: 97,
  PaymentReminder: 98,
  Daily_Log_Discussion_Added: 99,
  Schedule_Item_Discussion_Added: 100,
  TO_DO_DISCUSSION_ADDED: 101,
  OwnerRequestedChangeOrder: 102,
  BuilderSentSurvey: 103,
  OwnerSubmittedSurvey: 105,
  LeadActivityAssigned: 106,
  TimeClock_Adjustment: 107,
  CustomerInvoice: 108,
  LeadProposalReleased: 109,
  CustomerInvoiceUpdated: 110,
  TimeClock_OvertimeReached: 111,
  CustomerInvoiceReminder: 112,
  CustomerInvoicePastDue: 113,
  TimeClock_LongShift: 114,
  LeadProposal_AcceptDecline: 116,
  LeadProposal_Viewed: 117,
  DailyLog_FilesAdded: 118,
  JobProposalReleased: 119,
  JobProposal_AcceptDecline: 120,
  JobProposal_Viewed: 121,
  SubOnlinePaymentWaiting: 122,
  ToDoFilesAdded: 125,
  LienWaiverSent: 126,
  LienWaiverSigned: 127,
  LienWaiverDeclined: 128,
  OnlinePaymentInvitation: 129,
  CustomerInvoiceFilesAdded: 130,
  OnlinePaymentSent: 131,
  OwnerPaymentDiscussionAdded: 132,
  PDF_Annotated: 134,
  Document_Uploaded: 135,
  OnlinePaymentReceiptToBuilder: 137,
  PhotoCommentAdded: 139,
  DocumentCommentAdded: 140,
  ScheduleItemFilesAdded: 141,
  OwnerSubUploadedDocs: 142,
  OwnerPaymentAdded: 143,
  BillConvertedToPO: 144,
  Video_Uploaded: 145,
  VideoCommentAdded: 147,
  LeadUnsubscribed: 148,
  LienWaiverFilesAdded: 149,
  PODocumentsAddedBySub: 150,
  Todos_PastDue: 152,
  WarrantyServiceInternallyAssigned: 153,
  LeadProposalPaymentDueReminder: 154,
  PhotoAdded: 155,
  ChangeOrderApprovalRetracted: 156,
  LeadUnsubscribeConfirmation: 157,
  RFIAddedByBuilder: 158,
  RFIReminder: 159,
  RFIResponseAdded: 160,
  RFIAddedBySub: 161,
  RFICompletedReopened: 162,
  RFIAssignedToYou: 163,
  PO_Voided_By_Builder: 164,
  RFIPastDue: 165,
  RFIFilesAdded: 166,
  RiskInsuranceApprovedDenied: 167,
  RiskInsurancePolicyReceived: 168,
  RiskInsuranceIndividualBindersReceived: 169,
  LeadActivityUpdate: 170,
  PdfSignatureRequestAssigned: 171,
  PdfSignatureRequestSigned: 172,
  PdfSignatureRequestReminder: 173,
  PdfSignatureRequestPastDue: 174,
  PdfSignatureRequestResetToPending: 175,
  EmailLinkClicked: 177,
  LeadProposalPaymentMade: 179,
  SUB_ACTIVATION_REQUESTED: 180,
  MassReassign: 181,
  JobsiteViewingAccess: 182,
  LeadProposalPastDue: 183,
  EstimatePastDue: 184,
  TimeClock_OutOfBoundsShift: 185,
  BidSubmittedReceipt: 186,
  POReceipt: 187,
  CreditMemoAdded: 188,
  UserActivationRequest: 190,
  InternalUserActivated: 191,
  RECEIPTS_DISCUSSION_ADDED: 192,
  SUB_UPLOADED_CERTIFICATE: 193,
  BillReadyForPayment: 194,
  PaymentMethodMicrodepositSent: 195,
  CREDITMEMO_DISCUSSION_ADDED: 197,
  PO_Approval_Reminder: 198,
  BILL_DISCUSSION_ADDED: 199,
  NotificationPreferencesUpdated: 200,
  OutboundPaymentWithLienWaiverSent: 202,
  BillVoidedByBuilder: 203,
  BillSubRequestedPayment: 204,
  Quickbooks_Invoice_Override: 207,
  OwnerInvoicePaymentReceipt: 208,
  BillPaymentReceipt: 209,
  ReceiptUploaded: 210,
  OnlinePaymentFailed: 211,
  OnlinePaymentReceiptToClient: 212,
  ContactActivationRequest: 213,
  ContactActiveOwnerJobAccessGranted: 214,
  DepositDiscussionAdded: 215,
  DepositAdded: 216,
  DepositRequested: 217,
  PasswordChanged: 219,
  InboundHostedOnboardingApplicationStatusUpdate: 220,
  IntegrationSetupReminder: 221,
  DepositDueToday: 222,
  InviteOwnerToBuildertrend: 223,
  IntegrationReconsentReminder: 224,
  UnacceptedFundsReminder: 225,
  ChatMessage: 226,
  PPSPaymentRefundInitiated: 227,
  BTPaymentsAccountApproval: 228,
  SettlementCreated: 229,
  BTPaymentsAccountRejected: 230,
  FinancialDocumentsUploaded: 231,
  FinancialDocumentRequested: 232,
  PaymentThresholdLimitReached: 233,
  PaymentTotalLimitReached: 234,
  PasswordReset: 236,
  ForgotUsername: 237,
  MonthlyLimitSet: 238,
  PaymentDeclinedDueLimit: 239,
  PaymentLimitRemoved: 240,
  PaymentLimitUpdated: 241,
  AdminJobsiteRequestSubmitted: 242,
  BuilderRiskInsuranceApplicationSubmitted: 243,
  ProposalSignatureCaptured: 244,
  MonthlyPaymentLimitReset: 260,
  SMSPaymentLink: 261,
  PaymentRequested: 262,
  ClientUpdatePublished: 263,
  UsernameChangeViaReassignment: 264,
  UsernameChangePriorEmailNotification: 265,
  FinancialDocumentRequestedForInboundVerifiedAccount: 266,
  UsernameUpdated: 267,
  PaymentAccountDisabled: 268,
  BillPaymentMadeFromAccounting: 269,
  ClientUpdateAvailable: 270,
  SMSInvoiceDUE: 271,
  ClientUpdateDiscussionAdded: 272,
  TransactionLimitIncreaseRequestApproved: 273,
  TransactionLimitIncreaseRequestDeclined: 274,
  OnlinePaymentConfirmation: 275,
  ChangeOrderDeadLineReminder: 276,
  UserMention: 277,
  SubOnlinePaymentConfirmation: 278,
  JobProposalQuoteReleased: 279,
  InternalUserBillPaymentFailed: 280,
  SubOnlinePaymentFailed: 281,
  SubBankRequest: 282,
  CommentReaction: 283,
  SubBankAccountSaved: 284,
  ScheduleAssignment: 285,
  PurchaseOrderAmended: 286,
  Task_Discussion_Added: 287,
  PaymentsScheduleShared: 288,
  TaskAssigned: 289,
  CustomerFeedbackSubmitted: 290,
  BTPaymentsApplicationPending: 291,
  BTPaymentsUnifiedAccountRejected: 292,
  BillPendingApproval: 293,
  TaskDigest: 294,
  BillApprovalDailyDigest: 295,
  BillRejection: 296,
  PayerBankAccountAdded: 297,
  PayerBankAccountDefaultChanged: 298,
  Specification_Discussion_Added: 299,
  BillIntakeEmailFailure: 300,
  PlanPage_Discussion_Added: 301,
  TaskJustInTimeReminder: 302,
  TaskUpdated: 303,
  SpecificationPublished: 304,
  SELECTION_OPTION_DISCUSSION_ADDED: 305,
  BillIntakeProcessingFailure: 306,
  BillIntakeSenderProcessingFailure: 307,
  NewWayToGetPaidForSub: -9,
  Bid_RFIAnswerByReminder: -7,
  Bid_RFIAnswered: -6,
  Bid_RFIAssigned: -5,
  Bid_RFICreated: -4,
  PO_Finalized_For_Payment: -3,
  PO_Declined_Internal: -2,
  PO_Accepted_Declined_By_Sub: -1,
} as const;
